package org.lennycodes.hldi.pages
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.animation
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.css.textAlign
import com.varabyte.kobweb.compose.css.width
import com.varabyte.kobweb.compose.css.zIndex
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.breakpoint.ResponsiveValues
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.AnimationDirection
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.backgroundImage
import org.jetbrains.compose.web.css.backgroundPosition
import org.jetbrains.compose.web.css.backgroundSize
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.bottom
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.flexWrap
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.gridTemplateColumns
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.right
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.components.AnimatedCounter
import org.lennycodes.hldi.components.CustomSection
import org.lennycodes.hldi.components.GradientButton
import org.lennycodes.hldi.components.OutlinedButton
import org.lennycodes.hldi.components.ProgramCard
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.constants.RNInfo
import org.lennycodes.hldi.data.Program
import org.lennycodes.hldi.layouts.MainLayout
import org.lennycodes.hldi.styles.ButtonStyle
import org.lennycodes.hldi.styles.HeroDonateStyle
import org.lennycodes.hldi.styles.HomeHeroStyle
import org.lennycodes.hldi.styles.WobbleKeyframes


val FadeInDownKeyframes = Keyframes {
    from {
        Modifier
            .opacity(0)
            .transform {
                translateY((-30).px)
            }
    }

    to {
        Modifier
            .opacity(1)
            .transform {
                translateY(0.px)
            }
    }
}
@Page
@Composable
fun HomePage() {
    MainLayout {
        // Hero Section
        // Add this list near the top of the file (outside the @Composable function,
// same level as other top-level vals).
        val heroSlideImages = listOf(
            "one.webp",
            "two.webp",
            "three.webp",
            "four.webp",
            "five.webp",
            "six.webp",
            "seven.jpg",
            "eight.png",
            "nine.jpg",
            "ten.jpg",
            // add as many as you have — the slideshow cycles through all of them
        )


        var currentSlide by remember { mutableStateOf(0) }
        LaunchedEffect(Unit) {
            while (true) {
                delay(5000L)
                currentSlide = (currentSlide + 1) % heroSlideImages.size
            }
        }

        // Drop-in replacement for the Hero Section block in HomePage() — only the
// Section's height and the H1/P font-size lines changed; slides, animations,
// and the donate button are unchanged.

        Section(
            attrs = HomeHeroStyle.toAttrs {
                style {
                    // 100vh alone doesn't subtract Main's 80px top padding (added
                    // to clear the fixed navbar), so the section ran ~80px past
                    // the actual visible viewport at the bottom.
                    property("height", "calc(100vh - 80px)")
                }
            }
        ) {
            heroSlideImages.forEachIndexed { index, image ->
                Div(
                    attrs = {
                        attr("aria-hidden", "true") // purely decorative
                        style {
                            position(Position.Absolute)
                            top(0.px)
                            left(0.px)
                            right(0.px)
                            bottom(0.px)
                            backgroundImage("url('$image')")
                            backgroundSize("cover")
                            backgroundPosition("center")
                            zIndex(0) // below ::before's gradient overlay (z-index: 1)
                            opacity(if (index == currentSlide) 1.0 else 0.0)
                            property("transition", "opacity 1.5s ease-in-out")
                        }
                    }
                ) {}
            }

            Div(
                attrs = {
                    style {
                        position(Position.Relative)
                        zIndex(1)
                        maxWidth(800.px)
                        padding(0.px, 20.px)
                    }
                }
            ) {

                val fadeAnimation = FadeInDownKeyframes.toAnimation(
                    duration = 1.s,
                    timingFunction = AnimationTimingFunction.Ease
                )
                H1(
                    attrs = {
                        style {
                            property("font-size", "clamp(28px, 6vw + 1rem, 56px)")
                            fontWeight(700)
                            marginBottom(24.px)
                            fontFamily("Playfair Display", "serif")
                            lineHeight("1.2")
                            animation(fadeAnimation)
                        }
                    }
                ) {
                    Text("Defending Life, Restoring Hope, Transforming Communities")
                }
                val fadeAnimation2 = FadeInDownKeyframes.toAnimation(
                    duration = 3.s,
                    timingFunction = AnimationTimingFunction.Ease
                )
                P(
                    attrs = {
                        style {
                            property("font-size", "clamp(15px, 2.5vw + 0.5rem, 20px)")
                            marginBottom(48.px)
                            opacity(0.9)
                            animation(fadeAnimation2)
                        }
                    }
                ) {
                    Text("Rulenge Ngara - Human Life Defence Initiative is a registered Tanzanian Non-Governmental Organization (NGO) with registration number ${RNInfo.regNo} that works tirelessly to protect human dignity and empower vulnerable communities based in  Kagera region, operating under the umbrella of  Rulenge-Ngara Catholic Diocese")
                }
                val fadeAnimation3 = FadeInDownKeyframes.toAnimation(
                    duration = 6.s,
                    timingFunction = AnimationTimingFunction.Ease
                )
                Div(
                    attrs = {
                        style {
                            width(100.percent)
                            alignItems(AlignItems.Center)
                            display(DisplayStyle.Flex)
                            gap(16.px)
                            justifyContent(JustifyContent.Center)
                            flexWrap(FlexWrap.Wrap)
                            animation(fadeAnimation3)
                        }
                    }
                ) {
                    Div(
                        attrs = {
                            style {
                                display(DisplayStyle.Flex)
                                justifyContent(JustifyContent.Center)
                                alignItems(AlignItems.Center)
                            }
                        }
                    ) {
                        GradientButton(
                            text = "Donate Now",
                            href = "/get-involved",
                            modifier = Modifier.then(HeroDonateStyle.toModifier())
                        )
                    }
                }
            }
        }
        // Statistics Section
        Section {
            SimpleGrid(
                numColumns = ResponsiveValues(
                    1, // base (xs)
                    1, // sm
                    2, // md
                    3,  // lg+
                    4,
                    5
                ),
                modifier = Modifier
                    .gap(32.px)
            ) {
                AnimatedCounter(7000, "Lives Impacted")
                AnimatedCounter(500, "Communities Reached")
                AnimatedCounter(5, "Active Projects")
                AnimatedCounter(1, "Volunteers")
            }
        }

        // About Preview Section
        CustomSection(
            title = "About HLDI",
            subtitle = "We are dedicated to protecting human life and dignity through comprehensive humanitarian programs."
        )
        {
            Div(
                attrs = {
                    style {
                        display(DisplayStyle.Flex)
                        gap(48.px)
                        alignItems(AlignItems.Center)
                        flexWrap(FlexWrap.Wrap)
                    }
                }
            ) {
                Div(
                    attrs = {
                        style {
                            flex(1)
                            minWidth(300.px)
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Column)
                            alignItems(AlignItems.Center)   // centers children horizontally
                            textAlign(TextAlign.Center)      // centers text within H2/P
                        }
                    }
                ) {
                    H2(
                        attrs = {
                            style {
                                fontSize(32.px)
                                color(HLDITheme.Colors.primary)
                                marginBottom(20.px)
                                fontFamily("Playfair Display", "serif")
                            }
                        }
                    ) {
                        Text("Our Mission")
                    }
                    P(
                        attrs = {
                            style {
                                fontSize(16.px)
                                lineHeight("1.6")              // fixed: was lineHeight("")
                                color(HLDITheme.Colors.text)
                                marginBottom(24.px)
                                maxWidth(480.px)              // prevents centered text from stretching full-width
                            }
                        }
                    ) {
                        Text("RN – HLDI stands to provide for survival, protection, social harmony and development of all people in Rulenge Ngara - Catholic Diocese by addressing any conditions that threaten their physical and civil life and hinder socio-economic development.")
                    }
                    GradientButton(
                        text = "Read More",
                        href = "/about",
                        modifier = Modifier.then(ButtonStyle.toModifier())
                    )
                }
            }

            Div(
                attrs = {
                    style {
                        flex(1)
                        minWidth(300.px)
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        alignItems(AlignItems.Center)   // centers children horizontally
                        textAlign(TextAlign.Center)      // centers text within H2/P
                    }
                }
            ) {
                H2(
                    attrs = {
                        style {
                            fontSize(32.px)
                            color(HLDITheme.Colors.primary)
                            marginBottom(20.px)
                            fontFamily("Playfair Display", "serif")
                        }
                    }
                ) {
                    Text("Core Values")
                }
            }

                Div(
                    attrs = {
                        style {
                            flex(1)
                            minWidth(300.px)
                            display(DisplayStyle.Grid)
                            gridTemplateColumns("repeat(2, 1fr)")
                            gap(16.px)
                        }
                    }
                ) {

                    listOf(
                        "Compassion" to "❤️",
                        "Efficiency" to "⚡",
                        "Humility" to "🙏",
                        "Teamwork" to "🤝",
                        "Spirituality" to "✨",
                        "Commitment to Excellence" to "🏆",

                    ).forEach { (value, icon) ->
                        Div(
                            attrs = {
                                style {
                                    padding(24.px)
                                    backgroundColor(HLDITheme.Colors.white)
                                    borderRadius(12.px)
                                    textAlign(TextAlign.Center)
                                    boxShadow(0.px, 2.px, 8.px, color = Color.rgba(0, 0, 0, 0.08f))
                                }
                            }
                        ) {
                            Div(
                                attrs = {
                                    style {
                                        fontSize(32.px)
                                        marginBottom(12.px)
                                    }
                                }
                            ) {
                                Text(icon)
                            }
                            Div(
                                attrs = {
                                    style {
                                        fontWeight(600)
                                        color(HLDITheme.Colors.primary)
                                    }
                                }
                            ) {
                                Text(value)
                            }
                        }
                    }
                }
            }


         //program preview
        CustomSection(
            title = "Our Programs",
            subtitle = "Comprehensive humanitarian programs designed to address the most pressing needs of vulnerable communities.",
            modifier = Modifier.backgroundColor(HLDITheme.Colors.white)
        ) {
            SimpleGrid(
                numColumns = ResponsiveValues(
                    1, // base (xs)
                    1, // sm
                    2, // md
                    3,  // lg+
                    3,
                    3
                ),
                modifier = Modifier.gap(24.px)
            ) {
                allPrograms.take(3).forEach { program ->
                    ProgramCard(program)
                }
            }
            Div(
                attrs = {
                    style {
                        textAlign(TextAlign.Center)
                        marginTop(48.px)
                    }
                }
            ) {
                GradientButton(
                    text = "View All Programs",
                    href = "/programs",
                    modifier = Modifier.then(ButtonStyle.toModifier())
                )
            }
        }

    }
}
